import { render } from "./AuthPageView.vue?vue&type=template&id=30b711fc&ts=true"
import script from "./AuthPageView.vue?vue&type=script&lang=ts"
export * from "./AuthPageView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__